import { Api } from "../config/request";
export default {
  createFeedback(payload) {
    return Api.post("/rain-reporting/create-feedback", payload);
  },
};
